/**
 * EventStatusService
 * Service for managing event statuses
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for event status CRUD operations
 */
export class EventStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? EventStatusService.DEFAULT_SERVICE_PATH,
            basePath: EventStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
EventStatusService.DEFAULT_SERVICE_PATH = 'events';
EventStatusService.BASE_PATH = 'api/event-statuses';
//# sourceMappingURL=EventStatusService.js.map